{
  "header": "Uusimmat tiedotteet",
  "impersonate": {
    "text": "Kenno-käyttäjä {{impersonator}}"
  },
  "buttons": {
    "moreBulletins": "Lisää tiedotteita",
    "readBulletin": "Lue tiedote"
  },
  "pendingOperations": {
    "description": "Aloitit toimenpiteen, mutta et palannut tunnistautumisesta takaisin asukassivuille. Viimeistele toimenpide vahvistamalla se tai hylkää se.",
    "identificationRequired": "Toimenpiteen vahvistaminen edellyttää vahvaa tunnistautumista. Tunnistaudu, jotta voit vahvistaa toimenpiteen.",
    "terminationTitle": "Keskeneräinen irtisanomisilmoitus",
    "modificationTitle": "Keskeneräinen sopimusmuutos",
    "continue": "Jatka vahvistamista",
    "identify": "Tunnistaudu",
    "reject": "Hylkää",
    "error": "Vahvistamattomien operaatioiden hakeminen epäonnistui. Yritä myöhemmin uudelleen.",
    "rejectError": "Toimenpiteen hylkääminen epäonnistui. Yritä myöhemmin uudelleen."
  }
}
